<template>
  <div class="row">
    <div class="col-12">
      <!-- 개선 목록 -->
      <c-table
        ref="table"
        title="LBL0001174"
        tableId="impr01"
        :columns="gridImpr.columns"
        :data="riskReduce.imprs"
        :merge="gridImpr.merge"
        :gridHeight="setheight"
        @linkClick="linkClick"
      >
        <template v-slot:customArea="{ props, col }">
          <template v-if="col.name === 'riskHazardPicture'">
            <q-icon
              class="cursor-pointer"
              size="sm"
              color="blue-6"
              name="image"
              @click.stop="openHazardPicture(props)"
            />
          </template>
          <template v-else-if="col.name === 'picture'">
            <q-icon
              class="cursor-pointer"
              size="sm"
              color="green"
              name="image"
              @click.stop="openImprPicture(props)"
            />
          </template>
        </template>
      </c-table>
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
export default {
  name: "kras-impr",
  props: {
    riskReduce: {
      type: Object,
      default: function () {
        return {
          imprs: [],
          riskbooks: [],
        };
      },
    },
    height: {
      type: String,
      default: function () {
        return "";
      },
    },
  },
  data() {
    return {
      gridImpr: {
        merge: [
          { index: 0, colName: "processName" },
          { index: 1, colName: "groupMdmSopId" },
          { index: 2, colName: "riskHazardName" },
          { index: 3, colName: "riskHazardName" },
          { index: 4, colName: "ramKrasAssessScenarioId" },
          { index: 5, colName: "ramKrasAssessScenarioId" },
          { index: 6, colName: "ramKrasAssessScenarioId" },
          { index: 7, colName: "ramKrasAssessScenarioId" },
          { index: 8, colName: "ramKrasAssessScenarioId" },
        ],
        columns: [],
        data: [],
        height: "500px",
      },
      popupOptions: {
        target: null,
        title: "",
        visible: false,
        width: "80%",
        param: {},
        closeCallback: null,
      },
      editable: true,
      imprData: null,
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  computed: {
    setheight() {
      let pxRemove = this.height.replace("px", "");
      return this.height && this.height.indexOf("px") > -1 && !isNaN(pxRemove)
        ? Number(pxRemove) - 50 + "px"
        : "500px";
    },
  },
  methods: {
    init() {
      // role setting
      // url setting
      // code setting
      this.$comm.getStepItems("IBM_STEP_CD").then((_result) => {
        this.gridImpr.columns = [
          {
            name: "processName",
            field: "processName",
            label: "LBLPROCESS",
            align: "center",
            style: "width:150px",
            sortable: false,
          },
          {
            name: "jobName",
            field: "jobName",
            label: "작업순서",
            align: "left",
            style: "width:150px",
            sortable: false,
          },
          {
            name: "riskHazardPicture",
            field: "riskHazardPicture",
            // 사진
            label: "LBL0001175",
            align: "center",
            style: "width:40px",
            sortable: false,
            type: "custom",
          },
          {
            name: "riskHazardName",
            field: "riskHazardName",
            // 분류-유해위험요인
            label: "LBL0001020",
            align: "left",
            style: "width:250px",
            sortable: false,
          },
          {
            name: "riskOccurrenceCause",
            field: "riskOccurrenceCause",
            // 원인
            label: "LBL0001006",
            align: "left",
            style: "width:150px",
            sortable: false,
          },
          {
            name: "riskOccurrenceResult",
            field: "riskOccurrenceResult",
            // 결과
            label: "LBL0001007",
            align: "left",
            style: "width:150px",
            sortable: false,
          },
          {
            name: "currentSafetyMeasures",
            field: "currentSafetyMeasures",
            // 현재안전조치
            label: "LBL0001025",
            align: "left",
            style: "width:150px",
            sortable: false,
          },
          {
            name: "picture",
            field: "picture",
            // 개선<br/>전/후<br/>사진
            label: "개선 전/후 사진",
            align: "center",
            type: "custom",
            style: "width:70px",
            sortable: false,
          },
          {
            name: "improvementMeasures",
            field: "improvementMeasures",
            // 추가 리스크관리 계획
            label: "LBL0001122",
            align: "left",
            style: "width:150px",
            sortable: false,
          },
          {
            name: "ibmTitle",
            field: "ibmTitle",
            label: "LBLTITLE",
            align: "left",
            type: "link",
            style: "width:300px",
            sortable: true,
          },
          {
            name: "ibmStepCd",
            field: "ibmStepCd",
            label: "LBLPROGRESS",
            align: "center",
            style: "width:100px",
            type: "tag",
            colorItems: _result,
            sortable: false,
          },
          {
            name: "improveRequest",
            field: "improveRequest",
            // 요청부서정보
            label: "LBL0001016",
            align: "center",
            style: "width:250px",
            sortable: true,
          },
          {
            name: "actionCompleteRequestDate",
            field: "actionCompleteRequestDate",
            // 조치완료요청일
            label: "LBL0001017",
            align: "center",
            style: "width:100px",
            sortable: true,
          },
          {
            name: "actionDeptName",
            field: "actionDeptName",
            // 조치부서
            label: "LBL0001018",
            align: "center",
            style: "width:100px",
            sortable: true,
          },
        ];
      });
      // list setting
    },
    research() {
      this.$emit("research");
    },
    /* eslint-disable no-unused-vars */
    linkClick(row, col, index) {
      this.imprData = row;
      this.popupOptions.title = "LBLIMPROVE";
      this.popupOptions.param = {
        sopImprovementId: row.sopImprovementId,
      };
      this.popupOptions.target = () =>
        import(`${"@/pages/sop/ibm/imprDetail.vue"}`);
      this.popupOptions.width = "80%";
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeImprPopup;
    },
    closeImprPopup(result) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (result && result.col1) {
        this.$_.extend(this.imprData, result.col1);
        this.$refs["table"].$refs["compo-table"].resetVirtualScroll();
        this.research();
      }
    },
    openHazardPicture(props) {
      this.popupOptions.title = "유해위험요인 사진";
      this.popupOptions.param = {
        ramRiskHazardId: props.row.ramRiskHazardId,
        disabled: true,
      };
      this.popupOptions.target = () =>
        import(`${"@/pages/common/hazard/riskHazardPicture.vue"}`);
      this.popupOptions.width = "30%";
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeHazardPicturePopup;
    },
    closeHazardPicturePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
    },
    openImprPicture(props) {
      this.popupOptions.title = "개선 사진";
      this.popupOptions.param = {
        ramKrasAssessScenarioId: props.row.ramKrasAssessScenarioId,
        sopImprovementIds: props.row.sopImprovementIds,
        disabled: true,
      };
      this.popupOptions.target = () =>
        import(`${"@/pages/ram/kras/action/krasScenarioImprPicture.vue"}`);
      this.popupOptions.width = "60%";
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeScenarioImprPicturePopup;
    },
    closeScenarioImprPicturePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
    },
  },
};
</script>
